import { stripHtml } from 'utils/htmlContent';

export type PlanFeatureValue = boolean | string;

export interface PlanFeature {
  label: string;
  included: PlanFeatureValue;
}

export const getPackQuantity = (label: string): number => {
  const match = stripHtml(label).match(/\d+/);
  return match ? Number.parseInt(match[0], 10) : 0;
};

/** Ex.: 4 cervejas → "2 de cada"; 6 cervejas → "3 de cada". */
export const getPerBeerHint = (quantity: number): string | null => {
  if (quantity === 4) return '2 de cada';
  if (quantity === 6) return '3 de cada';
  return null;
};

export const getHighlightedPackId = (
  packs: { id: string; label: string }[],
): string | undefined => {
  if (packs.length === 0) return undefined;
  const fourPack = packs.find(pack => getPackQuantity(pack.label) === 4);
  return (fourPack ?? packs[Math.floor(packs.length / 2)] ?? packs[0]).id;
};

export const getPlanFeatures = (quantity: number): PlanFeature[] => [
  { label: 'Cervejas por mês', included: `${quantity} cervejas` },
  {
    label: 'Desconto na loja',
    // included: quantity >= 6 ? '20%' : quantity >= 4 ? '15%' : '10%',
    included: '20%',
  },
  { label: 'Cancelar quando quiser', included: true },
];

export const calcPlanSavings = (
  original: string | undefined,
  discounted: string | undefined,
): string => {
  if (!original || !discounted) return '0,00';
  const diff =
    (Number(original.replace(',', '.')) -
      Number(discounted.replace(',', '.'))) *
    12;
  return diff.toFixed(2).replace('.', ',');
};
